<div>
  <img src="assets/not-found.png" style="width: 100%; height: 100%;">
</div>